import { render, staticRenderFns } from "./ReassignTagForm.vue?vue&type=template&id=7707cd6c&"
import script from "./ReassignTagForm.vue?vue&type=script&lang=ts&"
export * from "./ReassignTagForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports